module.exports = __webpack_public_path__ + "img/06.847ea91f.png";